import React from "react";

const StudentsLife = () => {
  return <div>StudentsLife</div>;
};

export default StudentsLife;
